import { render, staticRenderFns } from "./modalAddCompany.vue?vue&type=template&id=6d6663ec&"
import script from "./modalAddCompany.vue?vue&type=script&lang=js&"
export * from "./modalAddCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports